export default {
  HOLDING_PERIOD(state, resp) {
    state.holdingPeriod = resp;
  },
};
